import axios from "axios";
import $ from "jquery";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";
import StepMenu from "../stepMenu";
import { listUniversity } from "../../../models/fieldSettings";
import { Select, Spin } from "antd";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import {
  lettersOnly,
  lowerCase,
  numberToMonth,
  groupByMultiple,
  upperCase,
} from "../../../utils";
import ConfirmModal from "../../confirmModal";
import CertificateUploading from "./uploads/certificateUploading";
import { IMAGES } from "../../../utils/data";

const { Option } = Select;
const StepThreeBed = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [isRedirect, setIsRedirect] = useState(false);
  const [validated, setValidated] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [captcha, setCaptcha] = useState([]);
  const [applicant, setApplicant] = useState([]);
  const [hscSubjects, setHscSubjects] = useState([]);
  const [minMark, setMinMarks] = useState(70);
  const [maxMark, setMaxMark] = useState(200);
  const [community, setCommunity] = useState("");
  const [subjectCount, setSubjectCount] = useState(0);
  const [board, setBoard] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [basic, setBaisc] = useState([]);
  const [savedMarks, setSavedMarks] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState([]);
  const [dataLoader, setDataLoader] = useState(false);
  // const [universityName, setUniversityName] = useState(savedMarks[0]?.university_name);
  const [universityName, setUniversityName] = useState("");

  const [universityList, setUniversityList] = useState([]);
  const [ugDegree, setUgDegree] = useState([]);
  const [ugDegreeList, setUgDegreeList] = useState([]);
  const [ugMajor, setUgMajor] = useState([]);
  const [medium, setMedium] = useState("");
  const [opted, setOpted] = useState("");
  const [majorSubqualification, setMajorSubqualification] = useState("");
  const [studiedUg, setStudiedUg] = useState(null);

  useEffect(() => {
    if (hscSubjects && hscSubjects.length > 0) {
      let m = [];
      for (let i = 0; i < subjectCount; i++) {
        if (i == 0 && board == "state") m.push(getMarksInfo(5));
        else if (i == 1 && board == "state") m.push(getMarksInfo(6));
        else m.push(getMarksInfo(false, i == 0 ? "Language" : ""));
      }
      setMarks(m);
    }
  }, [minMark, maxMark, subjectCount, board, hscSubjects]);

  const getMarksInfo = (sId, info = false) => {
    const subject = hscSubjects?.find((sub) => sub.id === sId) || null;

    return {
      subject_id: sId || "",
      subjectname: subject ? subject.name : "",
      subject_information: info,
      mark_scored: "",
      mark_maximum: maxMark,
      pass_month: 4,
      pass_year: new Date().getFullYear(),
      register_no: "",
      no_of_attempts: "",
      scored_total: "",
      max_total: "",
      part3_total: "",
      percentage: "",
    };
  };

  const [marks, setMarks] = useState([]);

  useEffect(() => {
    loadApplicantInfo();
    loadHscSubjects();
    loadUgForPg();

    listUniversity().then((res) => res && setUniversityList(res));
    if (props.pageType && props.pageType == "edit") loadData();
  }, []);

  useEffect(() => {
    if (
      savedMarks &&
      savedMarks.length > 0 &&
      savedMarks[0]?.opted_medium !== undefined
    ) {
      setOpted(savedMarks[0].opted_medium);
    }
  }, [savedMarks]);

  useEffect(() => {
    if (
      savedMarks &&
      savedMarks.length > 0 &&
      savedMarks[0]?.study_medium !== undefined
    ) {
      setMedium(savedMarks[0].study_medium);
    }
  }, [savedMarks]);

  useEffect(() => {
    if (
      savedMarks &&
      savedMarks.length > 0 &&
      savedMarks[0]?.university_name !== undefined
    ) {
      setUniversityName(savedMarks[0].university_name);
    }
  }, [savedMarks]);

  useEffect(() => {
    if (
      savedMarks &&
      savedMarks.length > 0 &&
      savedMarks[0]?.major_subqualification !== undefined
    ) {
      setMajorSubqualification(savedMarks[0].major_subqualification);
    }
  }, [savedMarks]);

  useEffect(() => {
    if (props.pageType === "edit" && ugDegreeList.length > 0) {
      handleStudiedDegreeChange(savedMarks.studied_degree);
    }
  }, [props.pageType, savedMarks, ugDegreeList]);

  const handleStudiedDegreeChange = (v) => {
    try {
      var d = ugDegreeList;
      var s = d.filter(function (obj) {
        return obj.ugdegree == v;
      });
      setUgMajor(s);
    } catch (error) {}
  };
  const handleMajorChange = (e) => {
    try {
      var v = e.target.value;
      var d = ugDegreeList;

      var index = d.findIndex(function (obj) {
        return obj.id == v;
      });

      if (index > -1) setStudiedUg(d[index].ugmajor);
    } catch (erro) {}
  };
  const loadData = () => {
    setDataLoader(true);
    setLoader(true);
    const form = new FormData();
    form.append("api_code", context.user.api_code);
    axios.post(ServiceUrl.UG.PERSONAL_MARKS_PREVIEW, form).then((res) => {
      if (res["data"].status == "1") {
        let d = res["data"].data.basic;
        let m = res["data"].data.marksbed;
        setBaisc(res["data"].data.basic);
        setSavedMarks(res["data"].data.marksbed);
        //setSavedMarks(res["data"].data.marks);

        setSchoolDetails(res["data"].data.schoolDetails);
        setCommunity(d.community);
        setBoard(d.board);

        let mr = [];
        m.map((item, i) => {
          mr.push({
            id: item.id,
            subject_id: item.subject_id,
            // subject_name: item.subject_name,
            subject_name: item.subject_name || item.subjectname, // Handle both cases
            subjectname: item.subjectname || item.subject_name, // Handle both cases
            mark_scored: parseFloat(item.mark_scored),
            mark_maximum: item.mark_maximum,
            pass_month: item.pass_month,
            pass_year: item.pass_year,
            register_no: item.register_no,
            no_of_attempts: item.no_of_attempts,
            scored_total: item.scored_total,
            max_total: item.max_total,
            part3_total: item.part3_total,
            percentage: item.percentage,
          });
        });

        setMarks(mr);
        setDataLoader(false);
      } else {
      }
      setLoader(false);
    });
  };

  const loadUgForPg = () => {
    try {
      setLoader(true);
      setUgDegree([]);
      setUgDegreeList([]);
      axios.get(ServiceUrl.PG.UG_FOR_PG + "?type=pg").then((res) => {
        if (res["data"].status == "1") {
          var d = groupByMultiple(res["data"].data, function (obj) {
            return [obj.ugdegree];
          });
          setUgDegree(d);
          setUgDegreeList(res["data"].data);
        }
      });
      setLoader(false);
    } catch (error) {}
  };

  const handleUniversityChange = (v) => {
    setUniversityName(v);
  };

  const marksField = (fieldName) => {
    if (savedMarks && savedMarks.length > 0 && savedMarks[0][fieldName])
      return savedMarks[0][fieldName];
  };

  const schoolField = (fieldName, index) => {
    if (
      schoolDetails &&
      schoolDetails.length > 0 &&
      schoolDetails[index][fieldName]
    )
      return schoolDetails[index][fieldName];
  };

  useEffect(() => {
    {
      let m = [];
      for (let i = 0; i < subjectCount; i++) {
        if (i == 0 && board == "state") m.push(getMarksInfo(5));
        else if (i == 1 && board == "state") m.push(getMarksInfo(6));
        else m.push(getMarksInfo(false, i == 0 ? "Language" : ""));
      }
      setMarks(m);
    }
  }, [minMark, maxMark, subjectCount, board]);

  const loadApplicantInfo = () => {
    try {
      setLoader(true);
      setApplicant([]);
      var form = new FormData();
      form.append("i__apiCode", context.user.api_code);
      axios.post(ServiceUrl.UG.APPLICANT_MIN_INFO, form).then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;
          setMinMarks(35);
          setMaxMark(100);
          setSubjectCount(5);
          setBoard(d.board);
          setCommunity(d.community);
          setApplicant(d);
          setLoader(false);
        } else {
          //toast.error(res["data"].message || "error");
          setLoader(false);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const loadHscSubjects = () => {
    try {
      setLoader(true);
      setHscSubjects([]);
      axios.get(ServiceUrl.UG.HSC_SUBJECTS).then((res) => {
        if (res["data"].status == "1") {
          setHscSubjects(res["data"].data);
        } else {
          setLoader(false);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const months = (sel) => {
    let rv = [];
    Array.from({ length: 12 }, (v, i) => {
      let n = ("0" + (i + 1)).slice(-2);
      rv.push(
        <option
          value={("0" + n).slice(-2)}
          selected={sel == i + 1 ? "selected" : ""}
        >
          {numberToMonth(n)}
        </option>,
      );
    });
    return rv;
  };

  const years = (sel) => {
    let rv = [];
    Array.from({ length: 17 }, (v, i) => {
      let n = new Date().getFullYear() - i;
      rv.push(
        <option value={n} selected={sel == n ? "selected" : ""}>
          {n}
        </option>,
      );
    });
    return rv;
  };

  const marksInputOnBlur = (item, e) => {
    let ds = e.target.dataset;
    let v = e.target.value;

    if (
      parseFloat(v) < parseFloat(ds.min) ||
      parseFloat(v) > parseFloat(ds.max)
    ) {
      toast.error("Enter correct mark");
      e.target.value = "";
      return;
    }
    let m = [...marks];
    let index = m.findIndex((obj) => obj.subject_id == item.subject_id);
    if (index > -1) {
      m[index]["mark_scored"] = v;
      setMarks(m);
    }
  };

  const getSubjectOptions = () => {
    let rv = [];
    hscSubjects.map((item, i) => {
      let index = marks.findIndex((obj) => obj.subject_id == item.id);
      if (index == -1) rv.push({ value: item.id, label: item.name });
    });
    return rv;
  };

  // const handleSubjectChange = (index, v) => {
  //   let m = [...marks];
  //   m[index]["subject_id"] = v;
  //   setMarks(m);
  // };

  //   const handleSubjectChange = (index, v) => {
  //   let m = [...marks];
  //   m[index]["subject_id"] = v;
  //   const selectedSubject = hscSubjects.find(sub => sub.id === v);
  //   if (selectedSubject) {
  //     m[index]["subjectname"] = selectedSubject.name;
  //   }
  //   setMarks(m);
  // };

  const handleSubjectChange = (index, v) => {
    let m = [...marks];
    m[index]["subject_id"] = v;
    const selectedSubject = hscSubjects.find((sub) => sub.id === v);
    if (selectedSubject) {
      m[index]["subjectname"] = selectedSubject.name;
    }
    setMarks(m);
  };

  const handleInputChange = (item, fieldName, e) => {
    let m = [...marks];
    let index = m.findIndex((obj) => obj.subject_id == item.subject_id);
    if (index > -1) {
      m[index][fieldName] = e.target.value;
      setMarks(m);
    }
  };

  const getTotalByFieldName = (fieldName) => {
    let m = marks;
    let total = 0;
    m.map((item, i) => {
      let v = item[fieldName];
      if (v && parseFloat(v) > 0) total = parseFloat(total) + parseFloat(v);
    });
    return parseFloat(total);
  };

  const part3Total = () => {
    let m = marks;
    let total = 0;

    m.map((item, i) => {
      if (item.subject_id != 5 && item.subject_id != 6) {
        let v = item.mark_scored;
        if (v && parseFloat(v) > 0) total = parseFloat(total) + parseFloat(v);
      } else if (applicant.board != "state" && i != 0) {
        let v = item.mark_scored;
        if (v && parseFloat(v) > 0) total = parseFloat(total) + parseFloat(v);
      }
    });
    return parseFloat(total);
  };

  const part3Percentage = () => {
    let total = part3Total();
    return parseFloat((total / 400) * 100).toFixed(2);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setShowConfirm(true);
  };
  const submitForm = () => {
    setLoader(true);
    setShowConfirm(false);

    let url = ServiceUrl.UG.STEP_TWO_BED;
    if (props.pageType && props.pageType == "edit")
      url = ServiceUrl.UG.UPDATE_STEP_TWOBED;

    axios.post(url, $("#frmStepII").serialize()).then((res) => {
      if (res["data"].status == "1") {
        toast.success(res["data"].message || "Success");
        context.updateUser(res["data"].user);
        setLoader(false);
        setIsRedirect(true);
        if (props.pageType && props.pageType == "edit") props.history.push("/");
      } else {
        toast.error(res["data"].message || "Error");

        context.setLoader(false);
        setLoader(false);
        loadCaptcha();
      }
    });
  };

  const loadCaptcha = () => {
    try {
      setLoader(true);
      axios.get(ServiceUrl.ADMISSION.CAPTCHA).then((res) => {
        setCaptcha(res["data"]);
        setLoader(false);
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const getUniversityOptions = () => {
    let rv = [];
    universityList.map((item, i) => {
      rv.push({ value: item.name, label: item.name });
    });
    return rv;
  };

  const getMarksPayload = () => {
    return savedMarks.map((item) => {
      const subject = hscSubjects.find((sub) => sub.id === item.subject_id);
      return {
        ...item,
        subject_name: subject ? subject.name : item.subject_name || "",
      };
    });
  };

  const schoolArray = ["6th", "7th", "8th", "9th", "10th", "11th", "12th"];

  return (
    <>
      <div className="container mb-3">
        {context.settingValue("allow_pre_registration") == 1 ? (
          <div className="container bootstrap snippets bootdey">
            <div className="row">
              <ul className="notes">
                <li>
                  <div className="rotate-2 green-bg">
                    <h4>
                      <img
                        src={IMAGES.SUCCESS.default}
                        style={{ width: "50px" }}
                      />
                      <br />
                      PRE-REGISTRATION SUBMITTED SUCCESSFULLY
                    </h4>
                    <p></p>
                    <a href="#" className="text-danger pull-right">
                      <i className="fa fa-trash-o "></i>
                    </a>
                  </div>
                </li>
                <li>&nbsp;</li>
                <li>
                  <div className="rotate-2 red-bg">
                    <h4>
                      <img
                        src={IMAGES.INSTRUCTION.default}
                        style={{ width: "50px" }}
                      />
                      <br />
                      இக்கல்லூரியில் சேர்க்கைக்கு விண்ணப்பிக்க, +2 தேர்வு
                      முடிவுகள் வெளியான பின், மீதமுள்ள (3) (4) ஆகிய படிகளில்
                      தேவைப்படும் தகவல்களை நிரப்பி தங்கள் விண்ணப்பத்தை
                      சமர்ப்பிக்க வேண்டும்.
                      <br />
                      Soon after the publication of the +2 results, the
                      applicant must enter the details in Steps (3), and (4),
                      and complete the submission of the application
                    </h4>

                    <p></p>
                    <a href="#" className="text-danger pull-right">
                      <i className="fa fa-trash-o "></i>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <StepMenu activeKey="step3" pageType={props.pageType} />

                {dataLoader && (
                  <div className="text-center my-5">
                    <Spinner />
                  </div>
                )}
                {!dataLoader && (
                  <Card>
                    <Card.Header className="p-0 border-0 rounded-0 shadow-none">
                      <div className="py-1 px-3 new-color-header">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="ps-1">
                            <div
                              className="fs-9 text-muted fw-900 text-uppercase mb-0 opacity-75"
                              style={{ letterSpacing: "1.2px" }}
                            >
                              Applicant Profile
                            </div>
                            <div
                              className="fs-12 fw-bold text-dark text-uppercase mt-n1"
                              style={{ lineHeight: "1.1" }}
                            >
                              {applicant.name} {applicant.initial}
                            </div>
                          </div>

                          <div className="text-end pe-1">
                            <div
                              className="fs-9 text-muted fw-900 text-uppercase mb-0 opacity-75"
                              style={{ letterSpacing: "1.2px" }}
                            >
                              Registration Code
                            </div>
                            <div
                              className="fs-13 fw-900 text-theme mt-n1"
                              style={{ lineHeight: "1.1" }}
                            >
                              {applicant.user_code}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <Spin spinning={loader}>
                        {context.settingValue(
                          "admission_ug_cert_marksheet_require",
                        ) == "1" &&
                          context.settingValue(
                            "allow_to_upload_hsc_marksheet_step_2",
                          ) == "0" && (
                            <>
                              <Row className="context_box_title mt-2">
                                <Col md={12}>
                                  <h5>HSC Certificates</h5>
                                </Col>
                              </Row>

                              <CertificateUploading
                                applicant={applicant}
                                fileName="mark_sheet_path"
                                filePath={applicant.mark_sheet_path}
                                title="HSC Marksheet"
                                minSize={80000}
                                maxSize={300000}
                                content={
                                  <span>
                                    File should be in .png or .jpg or .pdf
                                    format only.
                                    <br />
                                    Upload HSC Marksheet
                                    <br />
                                    File size : 80 kb - 300 kb
                                    <br />
                                    <br />
                                    <span style={{ color: "red" }}>
                                      Note: Applicants can download their online
                                      mark statement, print it out, get it
                                      attested by the Principal or
                                      Headmaster/Headmistress, and upload the
                                      attested copy.
                                    </span>
                                  </span>
                                }
                                onSuccess={(e) => loadApplicantInfo()}
                              />
                            </>
                          )}

                        <Form
                          noValidate
                          validated={validated}
                          encType="multipart/form-data"
                          id="frmStepII"
                          method="post"
                          onSubmit={handleFormSubmit}
                        >
                          <input
                            type="hidden"
                            name="i__userId"
                            value={context.user.user_id}
                          />
                          <input
                            type="hidden"
                            name="i__userCode"
                            value={context.user.user_code}
                          />
                          <input
                            type="hidden"
                            name="i__apiCode"
                            value={context.user.api_code}
                          />

                          <input
                            type="hidden"
                            name="i__studiedUg"
                            value={studiedUg}
                          />

                          <input
                            type="hidden"
                            name="study_medium"
                            value={medium}
                          />

                          <input
                            type="hidden"
                            name="opted_medium"
                            value={opted}
                          />
                          <input
                            type="hidden"
                            name="major_subqualification"
                            value={majorSubqualification}
                          />
                          <input
                            type="hidden"
                            name="marks"
                            value={JSON.stringify(marks)}
                          />

                          {/* <Row className="context_box_title mt-2">
                            <Col md={12}>
                              <h5>Details of Marks Obtained</h5>
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col md={12}>
                              <div className="table-responsive">
                                <table className="table table-sm table-bordered hsc-mark-table">
                                  <thead className="bg-light">
                                    <tr>
                                      <th width="250">Subject</th>
                                      <th>Marks Scored</th>
                                      <th>Maximum Marks</th>
                                      <th>Month & Year of Passing</th>
                                      <th>Register No</th>
                                      <th>No.of Attempts</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {marks.map((item, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            {item.subject_information && (
                                              <span>
                                                {item.subject_information}
                                              </span>
                                            )}
                                            {board == "state" && i == 0 ? (
                                              "Part-I :Language "
                                            ) : board == "state" && i == 1 ? (
                                              "Part-II : English  "
                                            ) : (
                                              <Select
                                                showSearch
                                                style={{ width: "100%" }}
                                                placeholder="Select Subject"
                                                optionFilterProp="children"
                                                className="fw-bold"
                                                filterOption={(input, option) =>
                                                  lowerCase(
                                                    option?.label ?? "",
                                                  ).includes(lowerCase(input))
                                                }
                                                onChange={(v) =>
                                                  handleSubjectChange(i, v)
                                                }
                                                defaultValue={item.subjectname}
                                                options={getSubjectOptions()}
                                              ></Select>
                                            )}
                                          </td>
                                          <td>
                                            <Form.Control
                                              type="number"
                                              size="sm"
                                              className="cl__no__arrow i__mark_scored fw-bold"
                                              data-min={minMark}
                                              data-max={maxMark}
                                              min={minMark}
                                              max={maxMark}
                                              onWheel={(e) => e.target.blur()}
                                              onBlur={(e) =>
                                                marksInputOnBlur(item, e)
                                              }
                                              required
                                              defaultValue={item.mark_scored}
                                              step=".01"
                                              disabled={!item.subject_id}
                                            />
                                          </td>
                                          <td>
                                            <Form.Control
                                              type="number"
                                              size="sm"
                                              className="cl__no__arrow i__mark_scored fw-bold"
                                              value={item.mark_maximum}
                                              disabled={!item.subject_id}
                                              required
                                            />
                                          </td>
                                          <td>
                                            <Form.Control
                                              as="select"
                                              size="sm"
                                              className="fw-bold"
                                              disabled={!item.subject_id}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  item,
                                                  "pass_month",
                                                  e,
                                                )
                                              }
                                              required
                                            >
                                              {months(item.pass_month)}
                                            </Form.Control>
                                            <Form.Control
                                              as="select"
                                              size="sm"
                                              className="fw-bold"
                                              disabled={!item.subject_id}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  item,
                                                  "pass_year",
                                                  e,
                                                )
                                              }
                                              required
                                            >
                                              {years(item.pass_year)}
                                            </Form.Control>
                                          </td>
                                          <td>
                                            <Form.Control
                                              type="number"
                                              size="sm"
                                              className="cl__no__arrow i__mark_scored fw-bold"
                                              value={item.register_no}
                                              disabled={!item.subject_id}
                                              min={0}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  item,
                                                  "register_no",
                                                  e,
                                                )
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              required
                                            />
                                          </td>
                                          <td>
                                            <Form.Control
                                              type="number"
                                              size="sm"
                                              className="cl__no__arrow i__mark_scored fw-bold"
                                              value={item.no_of_attempts}
                                              disabled={!item.subject_id}
                                              min={1}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  item,
                                                  "no_of_attempts",
                                                  e,
                                                )
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              required
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td>Total</td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          className="fw-bold"
                                          size="sm"
                                          name="scored_total"
                                          value={getTotalByFieldName(
                                            "mark_scored",
                                          )}
                                          required
                                        />
                                      </td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          className="fw-bold"
                                          size="sm"
                                          name="max_total"
                                          value={getTotalByFieldName(
                                            "mark_maximum",
                                          )}
                                          required
                                        />
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </Col>
                          </Row>

                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Marks scored in Part III out of{" "}
                                {maxMark == 200 ? "800" : "400"}
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={2}>
                              <Form.Control
                                type="text"
                                className="text-uppercase fw-bold"
                                name="part3_total"
                                size="sm"
                                value={part3Total()}
                                required
                              />
                            </Col>
                          </Row>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Part-III Percentage (%)
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={2}>
                              <Form.Control
                                type="text"
                                className="text-uppercase fw-bold"
                                name="part3_percentage"
                                size="sm"
                                value={part3Percentage()}
                                required
                              />
                            </Col>
                          </Row> */}

                          <Row className="context_box_title mt-2">
                            <Col md={12}>
                              <h5>Details of Qualifications</h5>
                            </Col>
                          </Row>

                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                College Previously studied
                                {context.pgType == "mped" ? "(B.P.Ed)" : ""}
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type="text"
                                className="text-uppercase fw-bold"
                                name="i__collegeName"
                                size="sm"
                                // defaultValue={savedMarks.college_name}
                                defaultValue={savedMarks[0]?.college_name || ""}
                                placeholder="College Previously studied"
                                onKeyPress={(e) => lettersOnly(e)}
                                required
                              />
                            </Col>
                          </Row>

                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Place of the College Previously studied
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type="text"
                                className="text-uppercase fw-bold"
                                name="college_place"
                                size="sm"
                                placeholder="Place of the College"
                                defaultValue={savedMarks[0]?.college_place}
                                required
                              />
                            </Col>
                          </Row>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Name of the University
                                <span className="text-danger"> *</span>
                              </label>
                            </Col>
                            {/* <Col md={8}>
                                       <Form.Control
                                         type="hidden"
                                         name="i__universityName"
                                         value={universityName}
                                       />
                                       <Select
                                         showSearch
                                         style={{ width: "100%" }}
                                         placeholder="Select"
                                         optionFilterProp="children"
                                         className="text-uppercase fw-bold"
                                         filterOption={(input, option) =>
                                           lowerCase(option?.label ?? "").includes(
                                             lowerCase(input)
                                           )
                                         }
                                         onChange={(v) => handleUniversityChange(v)}
                                         defaultValue={savedMarks[0]?.university_name}
                                         options={getUniversityOptions()}
                                         allowClear
                                         required
                                       ></Select>
                                     </Col> */}
                            <Col md={8}>
                              <Form.Control
                                type="hidden"
                                name="i__universityName"
                                value={universityName}
                              />
                              <Select
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="Select"
                                optionFilterProp="children"
                                className="text-uppercase fw-bold"
                                filterOption={(input, option) =>
                                  lowerCase(option?.label ?? "").includes(
                                    lowerCase(input),
                                  )
                                }
                                onChange={(v) => handleUniversityChange(v)}
                                value={universityName}
                                options={getUniversityOptions()}
                                allowClear
                                required
                              ></Select>
                            </Col>
                          </Row>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Studied Degree & Major in UG/PG
                                <span className="text-danger"> *</span> 
                              </label>

                              <br />
                              <small className="text-danger"> Candidates who have completed a degree in Commerce or Economics alone are required to choose a PG programme.</small>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                as="select"
                                size="sm"
                                className="fw-bold"
                                name="i__studiedDegree"
                                onChange={(e) =>
                                  handleStudiedDegreeChange(e.target.value)
                                }
                                required
                              >
                                <option value=""> -Select- </option>
                                {ugDegree.map((item, i) => {
                                  return (
                                    <option
                                      value={item[0].ugdegree}
                                      selected={
                                        item[0].ugdegree ==
                                        savedMarks[0]?.studied_degree
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      {" "}
                                      {item[0].ugdegree}{" "}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                            </Col>

                            <Col md={4}>
                              <Form.Control
                                as="select"
                                size="sm"
                                className="fw-bold"
                                name="i__studiedMajor"
                                onChange={(e) => handleMajorChange(e)}
                                required
                              >
                                <option value=""> -Select- </option>
                                {ugMajor.map((item, i) => {
                                  return (
                                    <option
                                      value={item.id}
                                      data-id={item.id}
                                      selected={
                                        item.id == savedMarks[0]?.studied_ug
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      {" "}
                                      {upperCase(item.ugmajor)}{" "}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                            </Col>
                          </Row>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Percentage of UG/PG Degree Course – Major and
                                Allied
                              </label>
                              <br />
                              <small className="text-danger">
                                Note: Candidates who have completed a degree in
                                Commerce or Economics alone are required to
                                provide their PG marks.
                              </small>
                            </Col>

                            <Col md={4}>
                              <InputGroup size="sm">
                                <Form.Control
                                  type="number"
                                  className="text-uppercase fw-bold"
                                  name="percentageofmajor"
                                  size="sm"
                                  placeholder="Percentage of Major"
                                  defaultValue={savedMarks[0]?.percentage_major}
                                />
                                <InputGroup.Text className="fw-bold">
                                  %
                                </InputGroup.Text>
                              </InputGroup>
                            </Col>

                            <Col md={4}>
                              <InputGroup size="sm">
                                <Form.Control
                                  type="number"
                                  className="text-uppercase fw-bold"
                                  name="percentageofallied"
                                  size="sm"
                                  placeholder="Percentage of Allied"
                                  defaultValue={
                                    savedMarks[0]?.percentage_allied
                                  }
                                />
                                <InputGroup.Text className="fw-bold">
                                  %
                                </InputGroup.Text>
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Major subject in the higher Qualification
                              </label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                className="text-uppercase fw-bold"
                                as="select"
                                value={majorSubqualification}
                                onChange={(e) =>
                                  setMajorSubqualification(e.target.value)
                                }
                              >
                                <option value="">Select</option>
                                <option value="M.A">M.A</option>
                                <option value="M.SC">M.SC</option>
                                <option value="M.Com">M.Com</option>
                                <option value="M.Phil">M.Phil</option>
                                <option value="M.Phil">MCA</option>
                                <option value="M.Phil">M.E</option>
                                <option value="M.Phil">M.Tech</option>
                                <option value="Ph.D">Ph.D</option>
                              </Form.Control>
                            </Col>
                          </Row>
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>Month & Year of Passing</label>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                as="select"
                                size="sm"
                                className="fw-bold"
                                name="i__pgPassMonth"
                              >
                                {months(savedMarks[0]?.pass_month)}
                              </Form.Control>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                as="select"
                                size="sm"
                                className="fw-bold"
                                name="i__pgPassYear"
                              >
                                {years(savedMarks[0]?.pass_year)}
                              </Form.Control>
                            </Col>
                          </Row>
                          {/* <Row className="py-2 border-bottom">
                            <Col md={4}>
                                <label>Medium of Instruction</label>
                            </Col>
                            <Col md={8}>
                                <Form.Control as="select" 
                                value = {medium} 
                                className="text-uppercase fw-bold"
                                onChange={(e) => setMedium(e.target.value)}>
                                <option value="">Select Medium</option>
                                <option value="english">English</option>
                                <option value="tamil">Tamil</option>
                                </Form.Control>
                            </Col>
                            </Row>     */}
                          <Row className="py-2 border-bottom">
                            <Col md={4}>
                              <label>
                                Medium opted to write B.Ed. Examination
                              </label>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as="select"
                                value={opted}
                                className="text-uppercase fw-bold"
                                onChange={(e) => setOpted(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="english">English</option>
                                <option value="tamil">Tamil</option>
                              </Form.Control>
                            </Col>
                          </Row>

                          <Row className="mt-4">
                            {props.pageType && props.pageType == "edit" && (
                              <Col md={6}>
                                <Link to="/" className="btn btn-danger w-100">
                                  Cancel
                                </Link>
                              </Col>
                            )}
                            <Col
                              md={
                                props.pageType && props.pageType == "edit"
                                  ? 6
                                  : 12
                              }
                            >
                              <Button
                                type="submit"
                                variant="success"
                                className="w-100"
                                disabled={loader}
                              >
                                Save & Continue
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </Spin>
                    </Card.Body>
                  </Card>
                )}
              </Col>
            </Row>
          </>
        )}
      </div>

      <ConfirmModal
        title="Confirm"
        content={
          <div>
            Please check all the filled informations before processing. Do you
            want to proceed next ?
          </div>
        }
        confirmText="Save & Proceed"
        show={showConfirm}
        onHide={(e) => setShowConfirm(false)}
        onCancel={(e) => setShowConfirm(false)}
        onConfirm={(e) => submitForm()}
      />
    </>
  );
};

export default StepThreeBed;
